import RouterGuard from './_RouterGuards'
import store from '../store'
import MedicalAlleyStartsV3Index from '../components/medicalAlleyStarts/Index'

export default {
  maaStartsHome: {
    path: '/maa-starts',
    name: 'MAA Starts Index',
    component: MedicalAlleyStartsV3Index,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  maaStartsHomeV3: {
    path: '/maa-starts/v3',
    name: 'MAA Starts v3 Index',
    component: MedicalAlleyStartsV3Index,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/maaStarts.js